<svelte:head>
  <link href="/webflow/css/normalize.css" rel="stylesheet" type="text/css" />
  <link href="/webflow/css/components.css" rel="stylesheet" type="text/css" />
  <link href="/webflow/css/imx-data-site-redux.css" rel="stylesheet" type="text/css" />
  <link href="https://fonts.googleapis.com" rel="preconnect" />
  <link href="https://fonts.gstatic.com" rel="preconnect" crossorigin="anonymous" />
  <script src="https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js"></script>
  <script>
  WebFont.load({
    google: {
      families: [
        'Inconsolata:400,700',
        'Open Sans:300,300italic,400,400italic,600,600italic,700,700italic,800,800italic',
        'Source Code Pro:300,400,500,600,700',
      ],
    },
  })
  </script>
  <link href="/webflow/images/favicon.jpg" rel="shortcut icon" type="image/x-icon" />
  <link href="/webflow/images/webclip.png" rel="apple-touch-icon" />
</svelte:head>
